import {Component} from 'panel';
import last from 'lodash/last';
import throttle from 'lodash/throttle';

import {replaceByIndex} from 'common/util/array';

export class BuilderPaneBase extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'pane-index': `number`,
    };
  }

  constructor() {
    super();
    this.updateRenderedSize = throttle(this._updateRenderedSize, 200, {leading: true});
  }

  get config() {
    return {
      helpers: {
        clickedBackButton: () => this.previousPane(),
        getBuilderState: () => this.builderState,
        numPanes: () => this.builderState.panes.length,
        updateRenderedSize: () => this.updateRenderedSize(),
        updateRenderedSizeOnNextFrame: () => requestAnimationFrame(() => this.updateRenderedSize()),
        updateActiveIndex: (activeIndex) => this.updateBuilder({activeIndex}),
      },
    };
  }

  //region Pane methods

  nextPane(componentName) {
    this.updateBuilder({panes: this.builderState.panes.concat({componentName})});
  }

  previousPane() {
    this.updateBuilder({panes: this.builderState.panes.slice(0, -1)});
  }

  _updateRenderedSize() {
    // function behind this.updateRenderedSize() that is throttled on component init
    const firstDiv = this.el.querySelector(`div`);
    const {width, height} = (firstDiv && firstDiv.getBoundingClientRect()) || {};
    if (width || height) {
      const pane = this.builderState.panes[this.paneIndex];
      if (pane && (pane.width !== width || pane.height !== height)) {
        this.updateBuilder({
          panes: replaceByIndex(this.builderState.panes, this.paneIndex, {
            ...pane,
            width: width || this.defaultWidth,
            height,
          }),
        });
      }
    }
  }

  updateCurrentBuilderPane(attrs) {
    if (this.currentPane) {
      this.updateBuilder({panes: [...this.builderState.panes.slice(0, -1), {...this.currentPane, ...attrs}]});
    }
  }

  get currentPane() {
    return last(this.builderState.panes);
  }

  //endregion

  //region Attribute methods

  get paneIndex() {
    return this.attr(`pane-index`);
  }

  //endregion

  //region Builder methods

  get builderState() {
    return this.app.state[this.builderStateReference];
  }

  get builderStateReference() {
    const {builderStateReference} = this.app;
    if (!builderStateReference) {
      throw new Error(`builderStateReference must be declared`);
    }

    return builderStateReference;
  }

  updateBuilder(attrs = {}) {
    this.update({[this.builderStateReference]: {...this.builderState, ...attrs}});
  }

  //endregion
}
